import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { authRequired: false },
    component: () => import('@/pages/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: { authRequired: false },
    component: () => import('@/pages/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: { authRequired: false },
    component: () => import('@/pages/Contact.vue')
  },
  {
    path: '/support',
    name: 'Support',
    meta: { authRequired: false },
    component: () => import('@/pages/Support.vue')
  },
  {
    path: '/forum',
    name: 'Forum',
    meta: { authRequired: false },
    component: () => import('@/pages/Forum.vue')
  },
  {
    path: '/forum/:id',
    name: 'ViewForum',
    meta: { authRequired: false },
    component: () => import('@/pages/ViewForum.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: { authRequired: true },
    component: () => import('@/pages/Profile.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    meta: { authRequired: true },
    component: () => import('@/pages/Admin.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    meta: { authRequired: false },
    component: () => import('@/pages/PrivacyPolicy.vue')
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    meta: { authRequired: false },
    component: () => import('@/pages/TermsOfService.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    meta: { authRequired: false },
    component: () => import('@/pages/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
